<template>
    <section ref="nearbyLocations" class="property-geolink section-outline" :class="{'show-more': showMore}" v-if="currentList && currentList.length" comp="propertyGeolink">
        <div class="f2 text-bold">Explore nearby locations</div>
        <ul>
            <li>
                <button :class="{'active': type === 'city'}" type="button" v-if="cities.length" @click="toggle('city')">Cities</button>
            </li>
            <li>
                <button :class="{'active': type === 'zipcode'}" type="button" v-if="zipcodes.length" @click="toggle('zipcode')">Zip Codes</button>
            </li>
            <li>
                <button :class="{'active': type === 'neighborhood'}" type="button" v-if="neighborhoods.length" @click="toggle('neighborhood')">Neighborhoods</button>
            </li>
        </ul>
        <div class="property-linklist" :class="{'show': type === 'city'}" v-if="cities.length">
            <div v-for="city in cities" :key="city.name">
                <a :href="`${glb.appUrl}${city.url}`">{{city.name}} homes for sale</a>
                <p>{{$filters.formatPrice(city.price)}}</p>
            </div>
        </div>
        <div class="property-linklist" :class="{'show': type === 'zipcode'}" v-if="zipcodes.length">
            <div v-for="zipcode in zipcodes" :key="zipcode.name">
                <a :href="`${glb.appUrl}${zipcode.url}`">{{zipcode.name}} homes for sale</a>
                <p>{{$filters.formatPrice(zipcode.price)}}</p>
            </div>
        </div>
        <div class="property-linklist" :class="{'show': type === 'neighborhood'}" v-if="neighborhoods.length">
            <div v-for="neighborhood in neighborhoods" :key="neighborhood.name">
                <a :href="`${glb.appUrl}${neighborhood.url}`">{{neighborhood.name}} homes for sale</a>
                <p>{{$filters.formatPrice(neighborhood.price)}}</p>
            </div>
        </div>
        <button v-if="currentList && currentList.length > 5" type="button" @click="toggleShowMore">{{ showMore ? 'Show Less' : 'Show More' }} <i :class="showMore ? 'icon-angle-up' : 'icon-angle-down'"></i></button>
    </section>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'propertyGeoLink',
    data() {
        return {
            selectedType: '',
            showMore: false,
        };
    },
    methods: {
        toggle(type) {
            this.selectedType = type;
        },
        toggleShowMore() {
            this.showMore = !this.showMore;
        },
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dpp', ['dpp']),
        type() {
            if (this.selectedType) {
                return this.selectedType;
            } else if (this.dpp.seoNearbyCity && this.dpp.seoNearbyCity.length) {
                return 'city';
            } else if (this.dpp.seoNearbyZipCode && this.dpp.seoNearbyZipCode.length) {
                return 'zipcode';
            } else if (this.dpp.seoNearbyNeighborhood && this.dpp.seoNearbyNeighborhood.length) {
                return 'neighborhood';
            } else if (this.dpp.seoNearbyCounty && this.dpp.seoNearbyCounty.length) {
                return 'county';
            }
            return null;
        },
        cities() {
            if (this.dpp.seoNearbyCity && this.dpp.seoNearbyCity.length) {
                return this.dpp.seoNearbyCity
                    .map((city) => {
                        return {
                            name: city.displayName,
                            price: city.medianListPrice,
                            url: city.sitemapCityPropertyPageUrl,
                        };
                    })
                    .slice(0, 10);
            }
            return [];
        },
        zipcodes() {
            if (this.dpp.seoNearbyZipCode && this.dpp.seoNearbyZipCode.length) {
                return this.dpp.seoNearbyZipCode
                    .map((zipcode) => {
                        return {
                            name: `${zipcode.displayName}, ${zipcode.stateCode}`,
                            price: zipcode.medianListPrice,
                            url: zipcode.sitemapZipCodePageUrl,
                        };
                    })
                    .slice(0, 10);
            }
            return [];
        },
        neighborhoods() {
            if (this.dpp.seoNearbyNeighborhood && this.dpp.seoNearbyNeighborhood.length) {
                return this.dpp.seoNearbyNeighborhood
                    .map((neighborhood) => {
                        return {
                            name: neighborhood.displayName,
                            price: neighborhood.medianListPrice,
                            url: neighborhood.sitemapNeighborhoodPageUrl,
                        };
                    })
                    .slice(0, 10);
            }
            return [];
        },
        counties() {
            if (this.dpp.seoNearbyCounty && this.dpp.seoNearbyCounty.length) {
                return this.dpp.seoNearbyCounty
                    .map((county) => {
                        return {
                            name: county.displayName,
                            price: county.medianListPrice,
                            url: county.sitemapCountyPageUrl,
                        };
                    })
                    .slice(0, 10);
            }
            return [];
        },
        currentList() {
            if (this.type === 'city') {
                return this.cities;
            } else if (this.type === 'zipcode') {
                return this.zipcodes;
            } else if (this.type === 'neighborhood') {
                return this.neighborhoods;
            } else if (this.type === 'county') {
                return this.counties;
            }
            return null;
        },
    },
};
</script>
<style lang="scss">
@use './property-geolink.scss' as *;
</style>